import api from "./../api";
import UtilsUrl from "../../utils/UtilsUrl";
export function getUnitsOfMeasurement() {
  return api
    .get(UtilsUrl.productionURL() + "/units-of-measurement")
    .then((res) => res.data);
}
